import { authSelectors } from 'ducks/auth'
import { chatDrawerActions, chatDrawerSelectors } from 'ducks/chatDrawer'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'types/state'

const pendingMessages: Array<{ message: string; timestamp: number }> = []

let globalChatContext: {
  setMessageText: (text: string) => void
  onSubmit: () => void
  messageText: string
} | null = null

export const registerChatContext = (context: typeof globalChatContext) => {
  globalChatContext = context
}

export const useAdaChat = () => {
  const dispatch = useDispatch()
  const chatDrawerOpen = useSelector((state: RootState) => chatDrawerSelectors.getChatDrawerOpen(state))
  const isPro = useSelector(authSelectors.getIsAuthenticatedPro)
  const osAssistantCode = isPro ? 'pro' : 'customer'

  const openChat = useCallback(() => {
    dispatch(chatDrawerActions.setChatDrawerOpen(true))
  }, [dispatch])

  const askAda = useCallback(
    (message: string) => {
      openChat()

      if (globalChatContext) {
        setTimeout(() => {
          globalChatContext!.setMessageText(message)
          setTimeout(() => {
            if (globalChatContext!.messageText.trim()) {
              globalChatContext!.onSubmit()
            }
          }, 50)
        }, 100)
      } else {
        pendingMessages.push({ message, timestamp: Date.now() })
      }
    },
    [openChat]
  )

  return {
    openChat,
    askAda,
    chatDrawerOpen,
    osAssistantCode,
  }
}
